<template>
    <footer class="iq-footer">
        <div class="container-fluid">
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-lg-6">
                            <ul class="list-inline mb-0">
                                <li class="list-inline-item"><a href="/backend/privacy-policy.html"></a></li>
                                <li class="list-inline-item"><a href="/backend/terms-of-service.html"></a></li>
                            </ul>
                        </div>
                        <div class="col-lg-6 text-right">
                            <span class="mr-1">2022 ©</span> <a href="https://lce-ci.com" class="">LCE</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</template>
<script>
export default {
    
}
</script>